var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccesKeysIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4125 9.75932V7.48193C3.4125 3.34978 6.58568 0 10.5 0C14.4143 0 17.5875 3.34978 17.5875 7.48193V9.75932C18.758 9.85165 19.5202 10.0845 20.0774 10.6728C21 11.6468 21 13.2143 21 16.3494C21 19.4845 21 21.052 20.0774 22.026C19.1547 23 17.6698 23 14.7 23H6.3C3.33015 23 1.84523 23 0.922614 22.026C0 21.052 0 19.4845 0 16.3494C0 13.2143 0 11.6468 0.922614 10.6728C1.47978 10.0845 2.24201 9.85165 3.4125 9.75932ZM4.9875 7.48193C4.9875 4.26804 7.45553 1.66265 10.5 1.66265C13.5445 1.66265 16.0125 4.26804 16.0125 7.48193V9.70279C15.6104 9.6988 15.1741 9.6988 14.7 9.6988H6.3C5.82591 9.6988 5.38966 9.6988 4.9875 9.70279V7.48193ZM10.5 13.3012C10.9349 13.3012 11.2875 13.6734 11.2875 14.1325V18.5663C11.2875 19.0254 10.9349 19.3976 10.5 19.3976C10.0651 19.3976 9.7125 19.0254 9.7125 18.5663V14.1325C9.7125 13.6734 10.0651 13.3012 10.5 13.3012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesKeysIcon);
export default __webpack_public_path__ + "static/media/AccesKeysIcon.2fdd2b748bc0ad67fa7ddaeceb1f6710.svg";
export { ForwardRef as ReactComponent };